import { render, staticRenderFns } from "./EResearch.vue?vue&type=template&id=3e0ae1d8&scoped=true"
import script from "./EResearch.vue?vue&type=script&lang=js"
export * from "./EResearch.vue?vue&type=script&lang=js"
import style0 from "./EResearch.vue?vue&type=style&index=0&id=3e0ae1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ae1d8",
  null
  
)

export default component.exports